module.exports = __webpack_public_path__ + "static/media/floor_w.d79dc6a9.png";